// src/pages/CourseTime/components/FloatingChatButton.comp.jsx
import React from 'react';
import { FloatingChatButton, UnreadBadge } from '../styles/discussion.styles';
import { GET_APP_LOCALIZE_TEXT } from '../../../utils/dq_lc_service/lc_service';

// Chat icon SVG component
const ChatIcon = () => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
    />
  </svg>
);

const FloatingChatButtonComponent = ({ onClick, disabled = false, themeColor, unreadCount = 0, pageLc }) => {
  // TODO: Re-enable unread count when multi-session logic is implemented
  // Helper to format unread count display
  // const formatUnreadCount = (count) => {
  //   if (count > 99) return '99+';
  //   return count.toString();
  // };

  const title = GET_APP_LOCALIZE_TEXT(pageLc, 'ct__open_discussion_forum');
  return (
    <FloatingChatButton
      onClick={onClick}
      disabled={disabled}
      themeColor={themeColor}
      title={title}
      aria-label={title}
    >
      <ChatIcon />
      {/* TODO: Re-enable unread count badge when multi-session logic is implemented */}
      {/* {unreadCount > 0 && (
        <UnreadBadge count={unreadCount}>
          {formatUnreadCount(unreadCount)}
        </UnreadBadge>
      )} */}
    </FloatingChatButton>
  );
};

export default FloatingChatButtonComponent;
